

class HandleExceptions {

    static throwException (message) {
        throw new Error(message);
    }
}

export default HandleExceptions;